// extracted by mini-css-extract-plugin
export default {"row":"ImageParametersStyles_row__9F1SU","sizeInput":"ImageParametersStyles_sizeInput__SLwYJ"};